import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { ConfigurationCardComponent } from "./components/configuration-card/configuration-card.component";
import { Configuration } from '../../../models/Configuration';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-configurations',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './configurations.component.html',
  styleUrl: './configurations.component.css'
})
export class ConfigurationsComponent {
}
